import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './counterpressurecylinder.component.html',
    standalone: false
})
export class CounterPressureCylinderPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  counterPressureCylinders: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.counterPressureCylinders = this.plugin.config.CounterPressureCylinders;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'counterpressurecylinder',
      'edit'
    ];
  }
}

PluginComponent.plugins['counterpressurecylinder'] = CounterPressureCylinderPluginComponent;
